import React from 'react'
import Skeleton from 'react-loading-skeleton'

const NotificationShimmer = ({ count = 5 }) => {
    return (
        <>
            {Array(count)
                .fill(0)
                .map((_, index) => (
                    <div className="notification_list" key={index}>
                        <div className="notification_request">
                            <Skeleton circle width="50%" />
                            <div className="notification_request">
                                <p>
                                    <b>{''}</b> <Skeleton width="70%" /></p>
                            </div>
                        </div>
                    </div>
                ))}
        </>
    )
}

export default NotificationShimmer